export const CUSTOM_BREAKPOINTS = {
    mobile: '(max-width: 768px)',
    tablet: '(max-width: 900px)',
    desktop: '(min-width: 901px)'
  };